import Geomap from "../../../src/visualization/connectedCharts/ConnectedGeomap";
import { buildMeta } from "../../routeMeta";

export function meta(args) {
  return buildMeta(
    {
      title: "Geo Map — The Atlas of Economic Complexity",
      description:
        "See which countries export or import a given product on a world map.",
      ogImage: "share_geo.png",
    },
    args,
  );
}

export default function GeomapRoute() {
  return <Geomap />;
}
